export const TAGS = {
  PROFILE: "Profile",
} as const;
